import { Component, effect, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRipple } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-search-field',
  imports: [MatFormFieldModule, MatInputModule, FontAwesomeModule, MatRipple],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchFieldComponent),
      multi: true,
    },
  ],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
})
export class SearchFieldComponent implements ControlValueAccessor {
  placeholder = input('Search');

  debounceMs = input(300);

  disabled = signal(false);

  searchText = output<string>();

  value = signal('');

  debounceTimer: ReturnType<typeof setTimeout> | undefined;

  initialized = false;

  constructor() {
    effect(() => {
      const currentValue = this.value();

      if (!this.initialized) {
        this.initialized = true;
        return;
      }

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.searchText.emit(currentValue);
        this.onChange(currentValue);
      }, this.debounceMs());
    });
  }

  updateValue(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value.set(input.value);
  }

  clear(): void {
    this.value.set('');
    this.onChange('');
  }

  // ControlValueAccessor

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  private onChange = (_: string) => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched = () => {};

  writeValue(value: string): void {
    this.value.set(value || '');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
